import { TableHeader } from "@/components/table"
import { Sort } from "@/domains/table-processor"

import { DisplaySortIcon } from "../display-sort-icon"

export const ThApr = ({ setSortBy, sortBy }: { setSortBy: (v: Sort) => void; sortBy: Sort }) => {
  return (
    <TableHeader
      classNameInner="justify-end"
      onClick={() => {
        setSortBy({
          key: "apr",
          direction: sortBy.direction === "asc" ? "desc" : "asc",
          type: "number",
        })
      }}
    >
      APR
      <DisplaySortIcon sortBy={sortBy} column="apr" />
    </TableHeader>
  )
}
